import { Component } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { AirdiskbrakeService } from 'src/app/services/feature/airdisk-brake/airdiskbrake.service';

@Component({
  selector: 'app-airdisk-tooltip-pop-up',
  templateUrl: './airdisk-tooltip-pop-up.component.html',
  styleUrls: ['./airdisk-tooltip-pop-up.component.scss'],
  standalone: false
})
export class AirdiskTooltipPopUpComponent {
  ToolTipTittle: any;
  ToolTipContent: any;
  ToolTipContent1: any;
  subscription = new Subscription();
  constructor(private readonly airdiskService: AirdiskbrakeService) { }

  ngOnInit() {
    this.subscription.add(this.airdiskService.toolTipData$.subscribe(x => {
      this.ToolTipTittle = x[0];
      this.ToolTipContent = x[1];
      if (x[2].length > 0) {
        this.ToolTipContent1 = x[2];
      }
    }));
  }
  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.subscription.unsubscribe();
  }

}
